import { Heading, Text } from '@insight-health-ai/roseate/components';
import type { FormBlock } from '../types';

type HeaderBlock = FormBlock & {
  title: string;
  description?: string;
  titleClassName?: string;
  descriptionClassName?: string;
};

export function Header({ block }: { block: HeaderBlock }) {
  return (
    <div className={block.className}>
      <Heading level={1} className={block.titleClassName}>
        {block.title}
      </Heading>
      {block.description && (
        <Text appearance="secondary" className={block.descriptionClassName}>
          {block.description}
        </Text>
      )}
    </div>
  );
}
